module.exports = __webpack_public_path__ + "img/icon_arrow-karet-big-white.4089c11a.svg";